import { useToast } from "../state";

// Meldingen onderin beeld; klik = wegklikken. Tekst is selecteerbaar zodat
// een fallback-melding met een URL ook handmatig te kopiëren is.
export const Toasts = () => {
  const toasts = useToast((s) => s.toasts);
  const dismiss = useToast((s) => s.dismiss);
  if (!toasts.length) return null;
  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[1000] flex flex-col gap-2 items-center max-w-[90vw]">
      {toasts.map((t) => (
        <div
          key={t.id}
          onClick={() => dismiss(t.id)}
          className="bg-dark-green text-white text-sm px-4 py-2 rounded-md shadow-lg select-all cursor-pointer break-all"
        >
          {t.text}
        </div>
      ))}
    </div>
  );
};
